"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpClient = void 0;
const cross_fetch_1 = __importDefault(require("cross-fetch"));
const category_1 = require("../resource/category");
const class_1 = require("../resource/class");
const classification_rule_1 = require("../resource/classification-rule");
const class_prediction_1 = require("../resource/class-prediction");
const job_1 = require("../resource/job");
const model_1 = require("../resource/model");
const organization_1 = require("../resource/organization");
const product_1 = require("../resource/product");
const taxonomy_1 = require("../resource/taxonomy");
const taxonomy_node_1 = require("../resource/taxonomy-node");
const user_1 = require("../resource/user");
const variant_group_1 = require("../resource/variant-group");
class HttpClient {
    constructor(config) {
        this.categories = new category_1.JsonapiCategoryRepository(config, cross_fetch_1.default);
        this.classes = new class_1.JsonapiClassRepository(config, cross_fetch_1.default);
        this.classificationRules = new classification_rule_1.JsonapiClassificationRuleRepository(config, cross_fetch_1.default);
        this.classPredictions = new class_prediction_1.JsonapiClassPredictionRepository(config, cross_fetch_1.default);
        this.jobs = new job_1.JsonapiJobRepository(config, cross_fetch_1.default);
        this.models = new model_1.JsonapiModelRepository(config, cross_fetch_1.default);
        this.organizations = new organization_1.JsonapiOrganizationRepository(config, cross_fetch_1.default);
        this.products = new product_1.JsonapiProductRepository(config, cross_fetch_1.default);
        this.taxonomies = new taxonomy_1.JsonapiTaxonomyRepository(config, cross_fetch_1.default);
        this.taxonomyNodes = new taxonomy_node_1.JsonapiTaxonomyNodeRepository(config, cross_fetch_1.default);
        this.users = new user_1.JsonapiUserRepository(config, cross_fetch_1.default);
        this.variantGroups = new variant_group_1.JsonapiVariantGroupRepository(config, cross_fetch_1.default);
    }
}
exports.HttpClient = HttpClient;
//# sourceMappingURL=http-client.js.map